import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                bannerheader: 'INSTITUTE OF IONOSPHERE',
                bannerbio:
                    'We are one of the oldest research institutes in Kazakhstan and the only specialized institute in Central Asia studying the state of the ionosphere.',
                labs: 'LABORATORIES',
                diagnosticlab: 'SPACE WEATHER DIAGNOSIS AND FORECAST LABORATORY',
                nonstationarylab:
                    'LABORATORY FOR NON-STATIONARY PROCESSES IN THE ATMOSPHERE AND IONOSPHERE',
                geomagneticlab: 'GEOMAGNETIC RESEARCH LABORATORY',
                reliabilitylab:
                    'LABORATORY FOR RELIABILITY AND SAFETY OF ORBITAL AND GROUND SPACE SYSTEMS',
                geodynamiclab: 'LABORATORY FOR SATELLITE AND GEODYNAMIC RESEARCH',
                complexlab: 'LABORATORY FOR COMPLEX ANALYSIS OF GROUND AND SPACE RESEARCH DATA',
                cartographylab: 'CARTOGRAPHY AND GIS LABORATORY',
                institute: 'INSTITUTE',
                performance: 'PERFORMANCE',
                services: 'SERVICES',
                committee:
                    'Aerospace Committee of the Ministry of Digital Development, Innovation and Aerospace Industry',
                blog: "Minister's blog",
                news: 'NEWS',
                history: 'HISTORY',
                staff: 'STAFF',
                experimentalbase: 'EXPERIMENTAL BASE',
                technicalequipment: 'TECHNICAL EQUIPMENT',
                youngscientists: 'COUNCIL OF YOUNG SCIENTISTS',
                anticorruption: 'ANTI-CORRUPTION PERFORMANCE',
                govpurchases: 'STATE PURCHASING',
                currentprojects: 'OUR PROJECTS',
                publications: 'PUBLICATIONS',
                seminars: 'SEMINARS AND CONFERENCES',
                patents: 'PATENTS',
                geophysicalforecast: 'FORECAST OF THE GEOPHYSICAL SITUATION',
                geomagneticdimensions: 'GEOMAGNETIC DIMENSIONS',
                aerospacemonitoring: 'AEROSPACE MONITORING',
                geoinformsystemdevelopment: 'DEVELOPMENT OF GEOINFORMATION SYSTEMS',
                adminsheader: 'ADMINISTRATION OF INSTITUTE',
                latestNewsHeader: 'Latest news',
                contactUsHeader: 'Contact us',
                head: 'Supervisor',
                mainScienceStaff: 'Core scientific staff',
                adminAndTechnicalStaff: 'Administrative and management staff',
                more: 'MORE',
                grantproject: 'Grant project',
                months: 'months',
                main: 'Main Page',
                anticor_1:
                    'The Ionosphere Institute is implementing a set of internal measures to prevent and combat corruption.',
                anticor_2:
                    "The activities are aimed at creating a system of value and moral anti-corruption guidelines for the institute's employees, preventing corruption and increasing the effectiveness of the application of anti-corruption legislation in the activities of the institute.",
                anticor_3:
                    'Among these activities is an annual internal analysis of corruption risks. Based on the results of the analysis, the institute takes all necessary measures to eliminate the identified corruption risks.',
                anticor_4:
                    'Analytical report on the results of an internal analysis of corruption risks in the activities of the Ionosphere Institute for the 1st quarter of 2023',
                anticor_5:
                    'Analytical report on the results of an internal analysis of corruption risks in the activities of the Ionosphere Institute, 2022',
                anticor_6:
                    'On March 20, 2023, at a meeting of the administrative and managerial staff and employees of the institute, a report was given on the topic “Explanation of the Law of the Republic of Kazakhstan”',
                anticor_7:
                    'On Anti-Corruption, Implementation of the Anti-Corruption Strategy of the Republic of Kazakhstan for 2015-2025.',
                anticor_8:
                    'Corruption is the abuse of official position for personal gain, the use by an official of his authority and the rights entrusted to him, as well as the authority, opportunities, and connections associated with this official status for personal gain, contrary to the law and moral principles.',
                anticor_9:
                    'You can get advice on anti-corruption issues at the Unified Call Center of the Anti-Corruption Service by calling 1424 (free call)',
                anticor_10: 'Call center 1424 advises citizens on: ',
                anticor_11: 'Anti-corruption; ',
                anticor_12: 'Receipts to the Anti-Corruption Service;',
                anticor_13: 'On the progress of consideration of applications and messages;',
                anticor_14: 'Other issues within the competence of the Anti-Corruption Service.',
                young_scientists_1:
                    'At the Institute of the Ionosphere there is a public organization of the Institute - the Council of Young Scientists.',
                young_scientists_2:
                    'The Council of Young Scientists is formed from representatives of various departments of the Institute.',
                young_scientists_3:
                    'The Council in its activities is guided by the current legislation of the Republic of Kazakhstan, the Charter of the Institute, resolutions and orders of the management of the Institute.',
                young_scientists_4:
                    'The general management of the activities of the Council is carried out by the Deputy Director for Research Work (R&D). The activities of the Council are carried out in contact with the research department and other departments of the Institute, which assist in its work.',
                young_scientists_5: 'GOALS AND OBJECTIVES OF THE COUNCIL',
                young_scientists_6:
                    'The goals of the Council are: to enhance the professional growth of young scientists of the Institute, to unite their efforts to develop current scientific problems and solve priority scientific problems, as well as to develop the innovative activities of young scientists of the Institute.',
                young_scientists_7: 'THE MAIN OBJECTIVES ARE:',
                young_scientists_8:
                    'Uniting young scientists of the Institute and intensifying their activities to achieve their goals, obtain new knowledge and integrate their joint scientific activities;',
                young_scientists_9:
                    'Assistance to young scientists of the Institute in conducting fundamental and applied research.',
                young_scientists_10: "The subject of the Council's activities are:",
                young_scientists_11:
                    'Representation of the interests of young scientists in the Academic Council of the Institute, in government bodies, public and other organizations, including the media);',
                young_scientists_12:
                    'Monitoring and analysis of the activities of young scientists of the Institute;',
                young_scientists_13:
                    'Establishing information exchange among young scientists and specialists of scientific organizations of the Institute: dissemination and exchange of information about printed and electronic sources of professional information, grants, funds, support programs for young scientists and specialists, conferences, schools, scientific and practical seminars and etc.;',
                young_scientists_14:
                    'Promoting the organization of conferences of young scientists of the Institute, seminars, series of lectures by leading scientists;',
                young_scientists_15:
                    'Promoting the creation of scientific and innovative projects of young scientists at the Institute, as well as other forms of organizing research activities;',
                young_scientists_16:
                    'Initiation of the organization of business societies, whose activities consist of the practical application (implementation) of the results of intellectual activity, for the participation of young scientists of the Institute in their work;',
                young_scientists_17:
                    'Preparing proposals for organizing full access for young scientists to the latest information technologies;',
                young_scientists_18:
                    'Participation in solving social and other problems of young scientists of the Institute;',
                young_scientists_20:
                    'Promoting financial support for the participation of young scientists in conferences, seminars, symposia, internships, including international ones;',
                young_scientists_21:
                    'Formation and expansion of a network of contacts with the Councils of Young Scientists of other scientific organizations, higher educational institutions;',
                young_scientists_22:
                    'Carrying out activities to attract schoolchildren and students of higher educational institutions to academic science, promoting the popularization of science;',
                young_scientists_23:
                    'Promoting the preservation and recreation of historical ones, as well as the formation of new traditions at the Institute;',
                young_scientists_24:
                    'Organization of sports and cultural leisure for young scientists and their families.',

                admin: {
                    3: {
                        lastName: 'Nurakynov',
                        name: 'Serik',
                        middleName: 'Maratovich',
                        position: 'Director',
                    },
                    5: {
                        lastName: 'Iskakov',
                        name: 'Berik',
                        middleName: 'Amaneldievich',
                        position: 'Deputy Director for R&D',
                    },
                    11: {
                        lastName: 'Kudaibergenov',
                        name: 'Muratbek',
                        middleName: 'Kasymbekovich',
                        position: 'Deputy Director for OV',
                    },
                    14: {
                        lastName: 'Iskalieva',
                        name: 'Gulnara',
                        middleName: '',
                        position: 'Scientific Secretary',
                    },
                },
            },
        },
        ru: {
            translation: {
                bannerheader: 'ИНСТИТУТ ИОНОСФЕРЫ',
                bannerbio:
                    'Мы являемся одним из старейших научно-исследовательских институтов в Казахстане и единственным в Средней Азии специализированным институтом, занимающийся изучением состояния ионосферы.',
                labs: 'ЛАБОРАТОРИИ',
                diagnosticlab: 'ЛАБОРАТОРИЯ ДИАГНОСТИКИ И ПРОГНОЗА КОСМИЧЕСКОЙ ПОГОДЫ',
                nonstationarylab: 'ЛАБОРАТОРИЯ НЕСТАЦИОНАРНЫХ ПРОЦЕССОВ В АТМОСФЕРЕ И ИОНОСФЕРЕ',
                geomagneticlab: 'ЛАБОРАТОРИЯ ГЕОМАГНИТНЫХ ИССЛЕДОВАНИЙ',
                reliabilitylab:
                    'ЛАБОРАТОРИЯ НАДЕЖНОСТИ И БЕЗОПАСНОСТИ ОРБИТАЛЬНЫХ И НАЗЕМНЫХ КОСМИЧЕСКИХ СИСТЕМ',
                geodynamiclab: 'ЛАБОРАТОРИЯ СПУТНИКОВЫХ И ГЕОДИНАМИЧЕСКИХ ИССЛЕДОВАНИЙ',
                complexlab:
                    'ЛАБОРАТОРИЯ КОМПЛЕКСНОГО АНАЛИЗА ДАННЫХ НАЗЕМНО-КОСМИЧЕСКИХ ИССЛЕДОВАНИЙ',
                cartographylab: 'ЛАБОРАТОРИЯ КАРТОГРАФИИ И ГИС',
                institute: 'ИНСТИТУТ',
                news: 'НОВОСТИ',
                history: 'ИСТОРИЯ',
                staff: 'ПЕРСОНАЛ',
                experimentalbase: 'ЭКСПЕРИМЕНТАЛЬНАЯ БАЗА',
                technicalequipment: 'ТЕХНИЧЕСКОЕ ОСНАЩЕНИЕ',
                youngscientists: 'СОВЕТ МОЛОДЫХ УЧЕНЫХ',
                anticorruption: 'АНТИКОРРУПЦИОННАЯ ДЕЯТЕЛЬНОСТЬ',
                govpurchases: 'ГОСЗАКУПКИ',
                performance: 'ДЕЯТЕЛЬНОСТЬ',
                currentprojects: 'ВЫПОЛНЯЕМЫЕ ПРОЕКТЫ',
                publications: 'ПУБЛИКАЦИИ',
                seminars: 'СЕМИНАРЫ И КОНФЕРЕНЦИИ',
                patents: 'ПАТЕНТЫ',
                services: 'УСЛУГИ',
                geophysicalforecast: 'ПРОГНОЗ ГЕОФИЗИЧЕСКОЙ ОБСТАНОВКИ',
                geomagneticdimensions: 'ГЕОМАГНИТНЫЕ ИЗМЕРЕНИЯ',
                aerospacemonitoring: 'АЭРОКОСМИЧЕСКИЙ МОНИТОРИНГ',
                geoinformsystemdevelopment: 'РАЗРАБОТКА ГЕОИНФОРМАЦИОННЫХ СИСТЕМ',
                committee:
                    'Аэрокосмический комитет Министерства цифрового развития, инноваций и аэрокосмической промышленности',
                adminsheader: 'АДМИНИСТРАЦИЯ ИНСТИТУТА',
                latestNewsHeader: 'Последние новости',
                contactUsHeader: 'Свяжитесь с нами',
                head: 'Руководитель',
                mainScienceStaff: 'Основной научный персонал',
                adminAndTechnicalStaff: 'Административно-управленческий персонал',
                more: 'ПОДРОБНЕЕ',
                grantproject: 'Грантовый проект',
                months: 'месяцев',
                main: 'Главная страница',
                anticor_1:
                    'Институт ионосферы реализует комплекс внутренних мероприятий по профилактике и противодействию коррупции. ',
                anticor_2:
                    'Мероприятия направлены на создание системы ценностных и моральных антикоррупционных ориентиров для сотрудников института, профилактику коррупционной деятельности и повышение эффективности применения антикоррупционного законодательства в деятельности института. ',
                anticor_3:
                    'В числе этих мероприятий – ежегодный внутренний анализ коррупционных рисков. По результатам анализа в институте принимаются все необходимые меры по устранению выявленных коррупционных рисков.',
                anticor_4:
                    'Аналитическая справка по результатам внутреннего анализа коррупционных рисков в деятельности ДТОО «Институт ионосферы» за 1 квартал 2023 года',
                anticor_5:
                    'Аналитическая справка по результатам внутреннего анализа коррупционных рисков в деятельности ДТОО «Институт ионосферы», 2022 год',
                anticor_6:
                    '20 марта 2023 года на заседании административно-управленческого персонала и сотрудников института был проведен доклад на тему «Разъяснение Закона РК',
                anticor_7:
                    '«О противодействии коррупции», «Реализация Антикоррупционной Стратегии Республики Казахстан на 2015-2025 годы».',
                anticor_8:
                    'Коррупция — злоупотребление служебным положением в личных целях, использование должностным лицом своих властных полномочий и доверенных ему прав, а также связанных с этим официальным статусом авторитета, возможностей, связей в целях личной выгоды, противоречащее законодательству и моральным установкам.',
                anticor_9:
                    'Получить консультацию по вопросам противодействия коррупции можно в Едином Call-центре Антикоррупционной службы по телефону 1424 (звонок бесплатный).',
                anticor_10: 'Саll-центр 1424 консультирует граждан по вопросам: ',
                anticor_11: 'Противодействия коррупции; ',
                anticor_12: 'Поступления в Антикоррупционную службу;',
                anticor_13: 'О ходе рассмотрения заявлений и сообщений;',
                anticor_14: 'Иные вопросы, входящие в компетенцию Антикоррупционной службы.',
                young_scientists_1:
                    'В Институте ионосферы действует общественная организация Института — Совет молодых ученых.',
                young_scientists_2:
                    'Совет молодых ученых формируется из представителей различных подразделений Института.',
                young_scientists_3:
                    'Совет в своей деятельности руководствуется действующим законодательством Республики Казахстан, Уставом Института, постановлениями и распоряжениями руководства Института.',
                young_scientists_4:
                    'Общее руководство деятельностью Совета осуществляет Заместитель директора по научно-исследовательской работе (НИР). Деятельность Совета осуществляется в контакте с отделом научно-исследовательской работы и другими подразделениями Института, которые оказывают содействие в его работе.',
                young_scientists_5: 'ЦЕЛИ И ЗАДАЧИ СОВЕТА',
                young_scientists_6:
                    'Целями деятельности Совета являются: активизация профессионального роста молодых ученых Института, объединение их усилий для разработки актуальных научных проблем и решения приоритетных научных задач, а также развития инновационной деятельности молодых ученых Института.',
                young_scientists_7: 'ОСНОВНЫМИ ЗАДАЧИ ЯВЛЯЮТСЯ:',
                young_scientists_8:
                    'Объединение молодых ученых Института и активизация их деятельности для выполнения поставленных целей, получения новых знаний и интеграция их совместной научной деятельности;',
                young_scientists_9:
                    'Содействие молодым ученым Института в проведении фундаментальных и прикладных исследований.',
                young_scientists_10: 'Предметом деятельности Совета являются:',
                young_scientists_11:
                    'Представление интересов молодых ученых в Ученом совете Института, в государственных органах, общественных и иных организациях, включая средствах массовой информации (СМИ);',
                young_scientists_12: 'Мониторинг и анализ деятельности молодых ученых Института;',
                young_scientists_13:
                    'Налаживание информационного обмена среди молодых ученых и специалистов научных организаций Института: распространение и обмен информацией о печатных и электронных источниках профессиональной информации, о грантах, фондах, программах поддержки молодых ученых и специалистов, конференциях, школах, научно-практических семинарах и т.д.;',
                young_scientists_14:
                    'Способствование организации проведения конференций молодых ученых Института, семинаров, циклов лекций ведущих ученых;',
                young_scientists_15:
                    'Способствование созданию в Институте научно-инновационных проектов молодых ученых, а также других форм организации научно- исследовательской деятельности;',
                young_scientists_16:
                    'Инициирование организации хозяйственных обществ, деятельность которых заключается в практическом применении (внедрении) результатов интеллектуальной деятельности, для участия в их работе молодых ученых Института;',
                young_scientists_17:
                    'Подготовка предложений по организации полноценного доступа молодых ученых к новейшим информационным технологиям;',
                young_scientists_18:
                    'Участие в решении социальных и других проблем молодых ученых Института;',
                young_scientists_20:
                    'Содействие финансовой поддержке участия молодых ученых в конференциях, семинарах, симпозиумах, стажировках, в том числе международных;',
                young_scientists_21:
                    'Формирование и расширение сети контактов с Советами молодых ученых других научных организаций, высших учебных заведений;',
                young_scientists_22:
                    'Проведение мероприятий по привлечению учащихся школ и студентов высших учебных заведений в академическую науку, способствование популяризации науки;',
                young_scientists_23:
                    'Содействие сохранению и воссозданию исторических, а также формированию новых традиций в Институте;',
                young_scientists_24:
                    'Организация спортивного и культурного досуга молодых ученых и их семей.',

                admin: {
                    3: {
                        lastName: 'Нуракынов',
                        name: 'Серик',
                        middleName: 'Маратович',
                        position: 'Директор',
                    },
                    5: {
                        lastName: 'Искаков',
                        name: 'Берик',
                        middleName: 'Амангельдиевич',
                        position: 'Заместитель директора по НИР',
                    },
                    11: {
                        lastName: 'Кудайбергенов',
                        name: 'Муратбек',
                        middleName: 'Касымбекович',
                        position: 'Заместитель директора по ОВ',
                    },
                    14: {
                        lastName: 'Искалиева',
                        name: 'Гульнара',
                        middleName: '',
                        position: 'Ученый секретарь',
                    },
                },
            },
        },
        kz: {
            translation: {
                bannerheader: 'ИОНОСФЕРА ИНСТИТУТЫ',
                bannerbio:
                    'Біз Қазақстандағы ең көне ғылыми-зерттеу институттарының бірі және ионосфера жағдайын зерттейтін Орталық Азиядағы жалғыз мамандандырылған институтпыз.',
                labs: 'ЗЕРТХАНАЛАР',
                institute: 'ИНСТИТУТ',
                news: 'ЖАҢАЛЫҚТАР',
                history: 'ТАРИХЫ',
                staff: 'ҚЫЗМЕТКЕРЛЕР',
                experimentalbase: 'ЭКСПЕРИМЕНТТЫҚ БАЗА',
                technicalequipment: 'ТЕХНИКАЛЫҚ ЖАБДЫҚ',
                youngscientists: 'ЖАС ҒАЛЫМДАР КЕҢЕСІ',
                anticorruption: 'ЖЕМҚОРЛЫҚҚА ҚАРСЫ ҚЫЗМЕТ',
                govpurchases: 'МЕМЛЕКЕТТІК САТЫП АЛУЛАР',
                performance: 'ІС-ШАРАЛАР',
                currentprojects: 'ЖҰМЫСТЫ ЖОБАЛАР',
                publications: 'БАСЫЛЫМДАР',
                seminars: 'СЕМИНАРЛАР МЕН КОНФЕРЕНЦИЯЛАР',
                patents: 'ПАТЕНТТЕР',
                services: 'ҚЫЗМЕТТЕР',
                geophysicalforecast: 'ГЕОФИЗИКАЛЫҚ ЖАҒДАЙЛАРДЫҢ БОЛЖАМЫ',
                geomagneticdimensions: 'ГЕОМАГНЕТИКАЛЫҚ ӨЛШЕМДЕР',
                aerospacemonitoring: 'АЭРОҒАРЫШТЫҚ МОНИТОРИНГ',
                geoinformsystemdevelopment: 'ГЕОАҚПАРАТТЫҚ ЖҮЙЕЛЕРДІ ДАМЫТУ',
                committee:
                    'Цифрлық даму, инновациялар және аэроғарыш өнеркәсібі министрлігінің Аэроғарыш комитеті',
                adminsheader: 'ИНСТИТУТ ӘКІМШІЛІГІ',
                latestNewsHeader: 'Соңғы жаңалықтар',
                head: 'Жетекшісі',
                diagnosticlab: 'ҒАРЫШ АУА РАЙЫ ДИАГНОСТИКА ЖӘНЕ БОЛЖАУ ЗЕРТХАНАСЫ',
                nonstationarylab:
                    'АТМОСФЕРА ЖӘНЕ ИОНОСФЕРАДАҒЫ СТАЦИОНЕРЛІ ЕМЕС ПРОЦЕСТЕР ЗЕРТХАНАСЫ',
                geomagneticlab: 'ГЕОМАГНЕТИКАЛЫҚ ЗЕРТТЕУ ЗЕРТТЕУ ЗЕРТХАНАСЫ',
                reliabilitylab:
                    'ОРБИТАЛДЫҚ ЖӘНЕ ЖЕР КЕҢІСТІК ЖҮЙЕЛЕРІНІҢ СЕНІМДІЛІГІ МЕН ҚАУІПСІЗДІГІ ЗЕРТХАНАСЫ',
                geodynamiclab: 'СПУТНИКТІК ЖӘНЕ ГЕОДИНАМИКАЛЫҚ ЗЕРТТЕУЛЕРГЕ АРНАЛҒАН ЗЕРТХАНАСЫ',
                complexlab: 'ЖЕР-ҒАРЫШТЫҚ ЗЕРТТЕУ ДЕРЕКТЕРІН ЖАҢАЛЫҚ ТАЛДАУҒА АРНАЛҒАН ЗЕРТХАНАСЫ',
                cartographylab: 'КАРТОГРАФИЯ ЖӘНЕ ГИС ЗЕРТХАНАСЫ',
                mainScienceStaff: 'Негізгі ғылыми қызметкерлер',
                adminAndTechnicalStaff: 'Әкімшілік және басқару персоналы',
                more: 'ТОЛЫҒЫРАҚ',
                grantproject: 'Гранттық жоба',
                months: 'ай',
                main: 'Басты бет',
                anticor_1:
                    'Ионосфера институты сыбайлас жемқорлықтың алдын алу және онымен күресу бойынша ішкі шаралар кешенін жүзеге асыруда.',
                anticor_2:
                    'Іс-шаралар институт қызметкерлері үшін сыбайлас жемқорлыққа қарсы құндылық және моральдық нұсқаулықтар жүйесін құруға, сыбайлас жемқорлықтың алдын алуға және институт қызметінде сыбайлас жемқорлыққа қарсы заңнаманы қолданудың тиімділігін арттыруға бағытталған.',
                anticor_3:
                    'Осы іс-шаралардың қатарында сыбайлас жемқорлық тәуекелдеріне жыл сайынғы ішкі талдау жүргізіледі. Талдау нәтижелері бойынша институт анықталған сыбайлас жемқорлық тәуекелдерін жою бойынша барлық қажетті шараларды қабылдайды.',
                anticor_4:
                    '2023 жылдың 1 тоқсанындағы Ионосфера институтының қызметіндегі сыбайлас жемқорлық тәуекелдерін ішкі талдау нәтижелері туралы талдамалық есеп',
                anticor_5:
                    'Ионосфера институтының қызметіндегі сыбайлас жемқорлық тәуекелдерін ішкі талдау нәтижелері туралы аналитикалық есеп, 2022',
                anticor_6:
                    '2023 жылғы 20 наурызда институттың әкімшілік-басқару құрамы мен қызметкерлерінің жиналысында Қазақстан Республикасының Заңын түсіндіру» тақырыбында баяндама жасалды.',
                anticor_7:
                    'Сыбайлас жемқорлыққа қарсы іс-қимыл туралы, Қазақстан Республикасының 2015-2025 жылдарға арналған сыбайлас жемқорлыққа қарсы стратегиясын іске асыру.',
                anticor_8:
                    'Сыбайлас жемқорлық - бұл лауазымды тұлғаның өз билігін және оған сеніп тапсырылған құқықтарын, сондай-ақ осы лауазымдық мәртебеге байланысты өкілеттіктерін, мүмкіндіктерін және байланыстарын жеке бас пайдасы үшін пайдалануы, заңға және моральдық қағидаларға қайшы келеді',
                anticor_9:
                    'Сыбайлас жемқорлыққа қарсы қызметтің Бірыңғай байланыс орталығына 1424 (қоңырау шалу тегін) телефоны арқылы сыбайлас жемқорлыққа қарсы іс-қимыл мәселелері бойынша кеңес алуға болады',
                anticor_10: '1424 байланыс орталығы азаматтарға кеңес береді: ',
                anticor_11: 'Сыбайлас жемқорлыққа қарсы іс-қимыл; ',
                anticor_12: 'Сыбайлас жемқорлыққа қарсы қызметке түсетін түсімдер;',
                anticor_13: 'Өтініштер мен хабарламаларды қарау барысы туралы;',
                anticor_14:
                    'Сыбайлас жемқорлыққа қарсы қызметтің құзыретіне жататын өзге де мәселелер.',
                young_scientists_1:
                    'Ионосфера институтында институттың қоғамдық ұйымы – Жас ғалымдар кеңесі жұмыс істейді.',
                young_scientists_2:
                    'Жас ғалымдар кеңесі институттың түрлі бөлімдерінің өкілдерінен құрылады.',
                young_scientists_3:
                    'Кеңес өз қызметінде Қазақстан Республикасының қолданыстағы заңнамасын, Институт Жарғысын, Институт басшылығының қаулылары мен өкімдерін басшылыққа алады.',
                young_scientists_4:
                    'Кеңес қызметіне жалпы басшылықты директордың ғылыми жұмыстар (ҒЗТКЖ) жөніндегі орынбасары жүзеге асырады. Кеңес қызметі институттың ғылыми-зерттеу бөлімімен және басқа бөлімшелерімен байланыста жүзеге асырылады, олар жұмысына көмектесу',
                young_scientists_5: 'Кеңестің МАҚСАТЫ МЕН МІНДЕТТЕРІ',
                young_scientists_6:
                    'Кеңестің мақсаты: Институттың жас ғалымдарының кәсіби өсуін арттыру, олардың күш- жігерін қазіргі ғылыми мәселелерді әзірлеу және басым ғылыми мәселелерді шешу үшін біріктіру, сондай- ақ жас ғалымдардың инновациялық қызметін дамыту.институтының.',
                young_scientists_7: 'НЕГІЗГІ МАҚСАТТАР:',
                young_scientists_8:
                    'Институттың жас ғалымдарын біріктіру және олардың мақсаттарына жету, жаңа білім алу және бірлескен ғылыми қызметтерін біріктіру үшін олардың қызметін жандандыру;',
                young_scientists_9:
                    'Институттың жас ғалымдарына іргелі және қолданбалы зерттеулер жүргізуге көмек көрсету.',
                young_scientists_10: 'Кеңес қызметінің тақырыбы:',
                young_scientists_11:
                    'Институттың Ғылыми кеңесінде, мемлекеттік органдарда, қоғамдық және басқа да ұйымдарда, соның ішінде БАҚ-та жас ғалымдардың мүдделерін білдіру);',
                young_scientists_12: 'Институттың жас ғалымдарының қызметін бақылау және талдау;',
                young_scientists_13:
                    'Институттың ғылыми ұйымдарының жас ғалымдары мен мамандары арасында ақпарат алмасуды жолға қою: кәсіби ақпараттың баспа және электронды көздері, гранттар, қорлар, жас ғалымдар мен мамандарды қолдау бағдарламалары, конференциялар, мектептер туралы ақпарат алмасу және тарату.ғылыми - практикалық семинарлар және т.б.;',
                young_scientists_14:
                    'Институттың жас ғалымдарының конференцияларын, семинарларын, жетекші ғалымдардың лекциялар топтамасын ұйымдастыруға ықпал ету;',
                young_scientists_15:
                    'Институтта жас ғалымдардың ғылыми-инновациялық жобаларын құруға, сондай-ақ ғылыми-зерттеу қызметін ұйымдастырудың басқа да нысандарына жәрдемдесу;',
                young_scientists_16:
                    'Қызметі зияткерлік қызметтің нәтижелерін практикалық қолданудан (енгізуден) тұратын кәсіпкерлік қоғамдарын олардың жұмысына Институттың жас ғалымдарының қатысуы үшін ұйымдастыруға бастамашылық ету;',
                young_scientists_17:
                    'Жас ғалымдардың соңғы ақпараттық технологияларға толық қолжетімділігін ұйымдастыру бойынша ұсыныстарды дайындау;',
                young_scientists_18:
                    'Институттың жас ғалымдарының әлеуметтік және басқа да мәселелерін шешуге қатысу;',
                young_scientists_20:
                    'Жас ғалымдардың конференцияларға, семинарларға, симпозиумдарға, тағылымдамаларға, оның ішінде халықаралық конференцияларға қатысуын қаржылық қолдауға жәрдемдесу;',
                young_scientists_21:
                    'Басқа ғылыми ұйымдардың, жоғары оқу орындарының Жас ғалымдар кеңестерімен байланыс желісін қалыптастыру және кеңейту;',
                young_scientists_22:
                    'Мектеп оқушылары мен жоғары оқу орындарының студенттерін академиялық ғылымға тарту, ғылымның танымал болуына ықпал ету бойынша іс-шараларды өткізу;',
                young_scientists_23:
                    'Институтта тарихи ескерткіштерді сақтау мен жаңғыртуға, сондай-ақ жаңа дәстүрлерді қалыптастыруға ықпал ету;',
                young_scientists_24:
                    'Жас ғалымдар мен олардың отбасыларының спорттық және мәдени бос уақытын ұйымдастыру',

                admin: {
                    3: {
                        lastName: 'Нұрақынов',
                        name: 'Серік',
                        middleName: 'Маратовұлы',
                        position: 'Директор',
                    },
                    5: {
                        lastName: 'Искаков',
                        name: 'Берік',
                        middleName: 'Амангельдіұлы',
                        position: 'ҒЗЖ бойынша директордың орынбасары',
                    },
                    11: {
                        lastName: 'Құдайбергенов',
                        name: 'Муратбек',
                        middleName: 'Қасымбекұлы',
                        position: 'ОВ бойынша директордың орынбасары',
                    },
                    14: {
                        lastName: 'Искалиева',
                        name: 'Гүлнара',
                        middleName: '',
                        position: 'Ғылыми хатшы',
                    },
                },
            },
        },
    },

    lng: 'ru', // language to use,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
